<app-header></app-header>
<div class="responsive">
    <div class="container-fluid">



         <div class="row">
            <div class="col-md-3">
                <app-sidebar></app-sidebar>
            </div>
            <div class="col-md-6">
                <div class="row margin-b">
                    <div class="col-md-12">
                        <app-sub-header title="Our Network"></app-sub-header>


                        <div class="display margin-b border-r">
                            <div class="header cursor " [ngClass]="{'active':activeTab === 'followers'}"
                                (click)="getScrollTo('followers')" id="individuals">Followers
                            </div>

                            <div class="header cursor " [ngClass]="{'active':activeTab === 'partner'}"
                                (click)="getScrollTo('partner')" id="fellowships">Partner
                            </div>
                        </div>


                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 col-xs-12">
                        <app-no-results-found *ngIf="objArr?.length == 0 && loading" [title]='activeTab'>
                        </app-no-results-found>

                        <div *ngIf="!loading">
                            <div *ngFor="let props of arr">
                                <app-card-skelton></app-card-skelton>
                            </div>
                        </div>
                        <div class="col-md-12" *ngIf="loading">
                            <div *ngFor="let props of (objArr | paginate
: {
itemsPerPage: pageSize,
currentPage: pageNo,
totalItems: totalItems
})">
                                <app-alert-card size=2 [showtext]=true [data]="props" title="Claim" [others]="false"
                                    [sideButton]="true" [route]="route" key="" (getBlock)="getBlockCommunity($event)">
                                </app-alert-card>

                            </div>
                        </div>
                        <div *ngIf="objArr?.length ==  pageSize" class="col-md-12" style="text-align: center;">
                            <pagination-controls class="col s12 col-md-offset-3 my-pagination"
                                *ngIf="objArr?.length > 0 " (pageChange)="page = userList($event)"
                                directionLinks="true" autoHide="false" responsive="true" previousLabel="Previous"
                                nextLabel="Next" screenReaderPaginationLabel="Pagination" screenReaderPageLabel="page"
                                screenReaderCurrentLabel="You're on page">
                            </pagination-controls>
                        </div>




                    </div>
                </div>


            </div>
            <div class="col-md-3">
                <app-events [showheader]=true></app-events>

            </div>
        </div>
    </div>
</div>
